// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/lm_close_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../img/lm_popout_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../img/lm_maximise_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../img/lm_minimize_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../img/lm_popin_white.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lm_goldenlayout {
  background: #000000;
}
.lm_content {
  background: #222222;
  border: 1px solid transparent;
}
.lm_dragProxy .lm_content {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9);
}
.lm_dropTargetIndicator {
  box-shadow: inset 0 0 30px #000000;
  outline: 1px dashed #cccccc;
}
.lm_dropTargetIndicator .lm_inner {
  background: #000000;
  opacity: 0.2;
}
.lm_splitter {
  background: #000000;
  opacity: 0.001;
  transition: opacity 200ms ease;
}
.lm_splitter:hover,
.lm_splitter.lm_dragging {
  background: #444444;
  opacity: 1;
}
.lm_header {
  height: 20px;
}
.lm_header .lm_tab {
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: #999999;
  background: #111111;
  box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.3);
  margin-right: 2px;
  padding-bottom: 2px;
  padding-top: 2px;
  /*.lm_title         // Present in LIGHT Theme
    {
      padding-top:1px;
    }*/
}
.lm_header .lm_tab .lm_close_tab {
  width: 11px;
  height: 11px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-repeat: no-repeat;
  top: 4px;
  right: 6px;
  opacity: 0.4;
}
.lm_header .lm_tab .lm_close_tab:hover {
  opacity: 1;
}
.lm_header .lm_tab.lm_active {
  border-bottom: none;
  box-shadow: 0 -2px 2px #000000;
  padding-bottom: 3px;
}
.lm_header .lm_tab.lm_active .lm_close_tab {
  opacity: 1;
}
.lm_header .lm_tab.lm_active.lm_focused {
  background-color: #354be3;
}
.lm_dragProxy.lm_right .lm_header .lm_tab.lm_active,
.lm_stack.lm_right .lm_header .lm_tab.lm_active {
  box-shadow: 2px -2px 2px #000000;
}
.lm_dragProxy.lm_bottom .lm_header .lm_tab,
.lm_stack.lm_bottom .lm_header .lm_tab {
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
}
.lm_dragProxy.lm_bottom .lm_header .lm_tab.lm_active,
.lm_stack.lm_bottom .lm_header .lm_tab.lm_active {
  box-shadow: 0 2px 2px #000000;
}
.lm_selected .lm_header {
  background-color: #452500;
}
.lm_tab:hover,
.lm_tab.lm_active {
  background: #222222;
  color: #dddddd;
}
.lm_header .lm_controls .lm_tabdropdown:before {
  color: #ffffff;
}
.lm_controls > * {
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  opacity: 0.4;
  transition: opacity 300ms ease;
}
.lm_controls > *:hover {
  opacity: 1;
}
.lm_controls .lm_popout {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.lm_controls .lm_maximise {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.lm_controls .lm_close {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.lm_maximised .lm_header {
  background-color: #000000;
}
.lm_maximised .lm_controls .lm_maximise {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.lm_transition_indicator {
  background-color: #000000;
  border: 1px dashed #555555;
}
.lm_popin {
  cursor: pointer;
}
.lm_popin .lm_bg {
  background: #ffffff;
  opacity: 0.3;
}
.lm_popin .lm_icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center center;
  background-repeat: no-repeat;
  border-left: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  opacity: 0.7;
}
.lm_popin:hover .lm_icon {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./node_modules/golden-layout/dist/css/themes/goldenlayout-dark-theme.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB;;;MAGI;AACN;AACA;EACE,WAAW;EACX,YAAY;EACZ,yDAAqD;EACrD,kCAAkC;EAClC,4BAA4B;EAC5B,QAAQ;EACR,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;EAC5B,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,yDAAsD;AACxD;AACA;EACE,yDAAwD;AAC1D;AACA;EACE,yDAAqD;AACvD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yDAAwD;AAC1D;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yDAAqD;EACrD,kCAAkC;EAClC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,UAAU;AACZ","sourcesContent":[".lm_goldenlayout {\n  background: #000000;\n}\n.lm_content {\n  background: #222222;\n  border: 1px solid transparent;\n}\n.lm_dragProxy .lm_content {\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9);\n}\n.lm_dropTargetIndicator {\n  box-shadow: inset 0 0 30px #000000;\n  outline: 1px dashed #cccccc;\n}\n.lm_dropTargetIndicator .lm_inner {\n  background: #000000;\n  opacity: 0.2;\n}\n.lm_splitter {\n  background: #000000;\n  opacity: 0.001;\n  transition: opacity 200ms ease;\n}\n.lm_splitter:hover,\n.lm_splitter.lm_dragging {\n  background: #444444;\n  opacity: 1;\n}\n.lm_header {\n  height: 20px;\n}\n.lm_header .lm_tab {\n  font-family: Arial, sans-serif;\n  font-size: 12px;\n  color: #999999;\n  background: #111111;\n  box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.3);\n  margin-right: 2px;\n  padding-bottom: 2px;\n  padding-top: 2px;\n  /*.lm_title         // Present in LIGHT Theme\n    {\n      padding-top:1px;\n    }*/\n}\n.lm_header .lm_tab .lm_close_tab {\n  width: 11px;\n  height: 11px;\n  background-image: url('../../img/lm_close_white.png');\n  background-position: center center;\n  background-repeat: no-repeat;\n  top: 4px;\n  right: 6px;\n  opacity: 0.4;\n}\n.lm_header .lm_tab .lm_close_tab:hover {\n  opacity: 1;\n}\n.lm_header .lm_tab.lm_active {\n  border-bottom: none;\n  box-shadow: 0 -2px 2px #000000;\n  padding-bottom: 3px;\n}\n.lm_header .lm_tab.lm_active .lm_close_tab {\n  opacity: 1;\n}\n.lm_header .lm_tab.lm_active.lm_focused {\n  background-color: #354be3;\n}\n.lm_dragProxy.lm_right .lm_header .lm_tab.lm_active,\n.lm_stack.lm_right .lm_header .lm_tab.lm_active {\n  box-shadow: 2px -2px 2px #000000;\n}\n.lm_dragProxy.lm_bottom .lm_header .lm_tab,\n.lm_stack.lm_bottom .lm_header .lm_tab {\n  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n}\n.lm_dragProxy.lm_bottom .lm_header .lm_tab.lm_active,\n.lm_stack.lm_bottom .lm_header .lm_tab.lm_active {\n  box-shadow: 0 2px 2px #000000;\n}\n.lm_selected .lm_header {\n  background-color: #452500;\n}\n.lm_tab:hover,\n.lm_tab.lm_active {\n  background: #222222;\n  color: #dddddd;\n}\n.lm_header .lm_controls .lm_tabdropdown:before {\n  color: #ffffff;\n}\n.lm_controls > * {\n  position: relative;\n  background-position: center center;\n  background-repeat: no-repeat;\n  opacity: 0.4;\n  transition: opacity 300ms ease;\n}\n.lm_controls > *:hover {\n  opacity: 1;\n}\n.lm_controls .lm_popout {\n  background-image: url('../../img/lm_popout_white.png');\n}\n.lm_controls .lm_maximise {\n  background-image: url('../../img/lm_maximise_white.png');\n}\n.lm_controls .lm_close {\n  background-image: url('../../img/lm_close_white.png');\n}\n.lm_maximised .lm_header {\n  background-color: #000000;\n}\n.lm_maximised .lm_controls .lm_maximise {\n  background-image: url('../../img/lm_minimize_white.png');\n}\n.lm_transition_indicator {\n  background-color: #000000;\n  border: 1px dashed #555555;\n}\n.lm_popin {\n  cursor: pointer;\n}\n.lm_popin .lm_bg {\n  background: #ffffff;\n  opacity: 0.3;\n}\n.lm_popin .lm_icon {\n  background-image: url('../../img/lm_popin_white.png');\n  background-position: center center;\n  background-repeat: no-repeat;\n  border-left: 1px solid #eeeeee;\n  border-top: 1px solid #eeeeee;\n  opacity: 0.7;\n}\n.lm_popin:hover .lm_icon {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
